// require jquery
import "jquery"; // jQuery (1.11.3)

// require jquery-sticky
import "@vendor/bower_components/jquery-sticky/jquery.sticky";

// require rails-ujs
import Rails from "@rails/ujs";

// require jquery-validation/dist/jquery.validate
import "@vendor/bower_components/jquery-validation/dist/jquery.validate";

// require jquery.textareaCounter
import "@vendor/javascripts/jquery.textareaCounter";

// require parsleyjs/dist/parsley
import "@vendor/bower_components/parsleyjs/dist/parsley";

// import { ResizeSensor } from "css-element-queries"; // see ProvidePlugin

// require handlebars.runtime
// require handlebars.helpers
// Handlebars setup has been moved to /app/assets/javascripts/handlebars

// require underscore/underscore
import "underscore";

// require_tree ./app
import "@assets/javascripts/app.tree";

Rails.start();

/*
TODO: Refactor/remove.
  This is holdover from the original implementation of the site. We should
  replace/remove it – cs
*/
for (var i in App) {
  if (typeof App[i].initialize == "function") {
    App[i].initialize && App[i].initialize();
  }
}
